function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 8,
  transform: "matrix(-1 0 0 1 8 8)",
  fill: "#FBFBFF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 4.99846,
  rx: 0.5,
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 8.94897 4.42993)",
  fill: "#394577"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 8,
  rx: 0.5,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 3.5166 7.5188)",
  fill: "#394577"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 1.00053,
  height: 5.02803,
  rx: 0.500265,
  transform: "matrix(0.707107 0.707107 0.707107 -0.707107 8.22046 10.8625)",
  fill: "#394577"
});

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.622854d6.svg";
export { ForwardRef as ReactComponent };